module.exports = __webpack_public_path__ + "img/CS-UL-HD-Profiles.ad8a12d3.jpg";